import { HAS_WINDOW } from '@eventbrite/feature-detection';
import {
    getAmplitudeInstance,
    loadAmplitude,
    trackIntercomEvent,
} from '@eventbrite/marketing-tools-common';
import { trackAnalyticsEvent } from '@eventbrite/site-analytics';
import { ACTIVATION_MODAL_CLICKED_GET_STARTED } from '../constants';

export const initAmplitudeTracking = () => loadAmplitude();

interface TrackEvent {
    category: string;
    action: string;
    path?: string;
    source?: string;
    feature?: string;
    extraItem?: { [key: string]: string };
}

const dictionaryPaths: { [key: string]: string } = {
    '': '',
    '/': 'Dashboard',
    '/add-to-facebook': 'Facebook Event',
    '/paid-social-ads': 'Ad Campaigns',
    '/playbooks/insights': 'Instagram Growth',
    '/playbooks': 'playbooks',
};

export const trackEvent = (props: TrackEvent) => {
    const path = props.path || '';
    const source = props.source ? props.source : dictionaryPaths[path];
    const extraItems = props.extraItem ? { ...props.extraItem } : undefined;

    trackAnalyticsEvent({
        category: props.category,
        action: props.action,
        label: props.feature ? `${source}-${props.feature}` : `${source}`,
        dimensions: extraItems,
    });

    getAmplitudeInstance().logEvent(props.category, {
        action: props.action,
        source: source,
        feature: props.feature,
        ...extraItems,
    });

    if (props.action === ACTIVATION_MODAL_CLICKED_GET_STARTED && HAS_WINDOW) {
        trackIntercomEvent('started trial', {
            email: window.__SERVER_DATA__?.user?.email,
        });

        getAmplitudeInstance().logEvent('Started Trial');
    }
};
